"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonLink = void 0;
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var ButtonLink = /** @class */ (function (_super) {
    __extends(ButtonLink, _super);
    function ButtonLink(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (event) {
            if (_this.props.disabled) {
                event.preventDefault();
                _this.setState({ showAlert: true });
            }
        };
        _this.state = {
            showAlert: false
        };
        return _this;
    }
    ButtonLink.prototype.render = function () {
        var btnTypeClassName;
        if (this.props.disabled) {
            btnTypeClassName = "btn-gray";
        }
        else if (this.props.primary) {
            btnTypeClassName = "btn-primary btn-next";
        }
        else {
            btnTypeClassName = "btn-white";
        }
        var btnClassName;
        if (this.props.btnClassName) {
            btnClassName = this.props.btnClassName;
        }
        else {
            btnClassName = "btn ".concat(btnTypeClassName, " plugin");
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(react_router_dom_1.Link, { to: this.props.routeState ? { pathname: this.props.to, state: this.props.routeState } : this.props.to, id: this.props.id, className: "buttonLink ".concat(this.props.className || ""), onClick: this.handleClick },
                React.createElement("button", { type: "button", disabled: this.props.disabled, className: "".concat(btnClassName) }, this.props.children))));
    };
    return ButtonLink;
}(React.Component));
exports.ButtonLink = ButtonLink;
//# sourceMappingURL=ButtonLink.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/ButtonLink.js
// module id = 1337
// module chunks = 0